// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"d370435d","225":"d370435d","552":"d370435d","722":"d370435d","840":"d370435d"}[chunkId] + ".chunk.css";
};